/* global axios */
const baseURL = accountId =>
  `/api/v1/accounts/${accountId}/aceleres/message_signatures`;

export default {
  list(accountId) {
    return axios.get(baseURL(accountId));
  },
  update(accountId, userId, enabled) {
    return axios.patch(`${baseURL(accountId)}/${userId}`, { enabled });
  },
};
